// Copyright 2024 - MinIO, Inc. All rights reserved.

import { Api } from "./nodesApi";

export let rootNodeApi = new Api();
